import offerSfogliatoreData from '../../data/sfogliatore.json';
import offerCartaData from '../../data/carta.json';
import {
  getTestata,
  filterOffersByCodeName,
  transformOnlineStripeOffers,
  getAndSanitizeQS,
  goToHref,
  getInitialOffer,
} from '../../lib/utils';
import { trackAndGoToHref } from '../Tracking/dataLayerEvents';
import { TESTATE } from '../../lib/constants';

function getCartaURL(params) {
  const searchParams = new URLSearchParams(params);
  const url = new URL(TESTATE[getTestata()].urlPurchaseCarta);
  searchParams.forEach((k, v) => {
    url.searchParams.set(k, v);
  });
  return url.toString();
}

function getSfogliatoreURL(params) {
  const searchParams = new URLSearchParams(params);
  const url = new URL(TESTATE[getTestata()].urlPurchaseSfogliatore);
  searchParams.forEach((k, v) => {
    url.searchParams.set(k, v);
  });
  return url.toString();
}

function getCheckoutURL(params) {
  const searchParams = new URLSearchParams(params);
  searchParams.append('page', 'checkout');
  return `/paywall?${searchParams.toString()}`;
}

export async function getDigitalOffers(offersFromUC, goToURLParams, brief) {
  const offerOnline = filterOffersByCodeName(
    transformOnlineStripeOffers(offersFromUC),
    getAndSanitizeQS('online'),
  );
  const offerSfogliatore = filterOffersByCodeName(
    offerSfogliatoreData,
    getAndSanitizeQS('sfogliatore'),
  );
  const userInfo = await window.authSession;
  const trackAndGoToOnlineOffer = trackAndGoToHref(
    getCheckoutURL(goToURLParams),
    userInfo,
    getInitialOffer(offersFromUC),
  );
  const goToOnlineOffer = goToHref(getCheckoutURL(goToURLParams));
  const goToSfogliatore = goToHref(getSfogliatoreURL(goToURLParams));
  return [
    { ...offerOnline, goTo: brief ? goToOnlineOffer : trackAndGoToOnlineOffer },
    { ...offerSfogliatore, goTo: goToSfogliatore },
  ];
}

export async function getAllOffers(onlineOffers, goToURLParams, brief) {
  const digitalOffers = await getDigitalOffers(onlineOffers, goToURLParams, brief);
  return [...digitalOffers, { ...offerCartaData, goTo: goToHref(getCartaURL(goToURLParams)) }];
}
